import moment from 'moment-timezone';
import { getVariableTagValue } from '../../../../../../../../../shared/components/tags-dropdown/helpers/get-variable-tag-value';
import { VariableTags } from '../../../../../../../../../shared/components/tags-dropdown';

export const extractTags = (content: string): string[] => {
  // Regular Expression to match all tags enclosed within {{}} and return array of all tags
  const regex = new RegExp('{{([^{}]*)}}', 'ig');
  const tags = [];
  content.replace(regex, (match, innerTagName) => {
    // This code is used get only first captured group (tagName without curly brackets)
    if (innerTagName) tags.push(innerTagName);
    return match;
  });
  return Array.from(new Set(tags));
};

const extractTagParts = (tagToMatch: string) =>
  // This regex will extract 3 parts of the tags:-
  // Tagname: {{CurrentDate + 5}}
  // tagName = "CurrentDate"
  // operator = "+"
  // offset = "5"
  // Note:- For tags without N value eg. {{Today}}, it will allow tagName it while keeping offset 0
  // This regex will allow any number of spaces around tagName, operator and offset
  // eslint-disable-next-line no-useless-escape
  tagToMatch.match(/^\s*([a-zA-Z]+)\s*(?:([+-\/])\s*([a-zA-Z0-9]+))?\s*$/);

const getVariableTagMapping = (
  tags: string[],
  timezone: string,
  senderDetails,
): Record<string, string> => {
  // Creating a mapping of all used variable merge tags with their respective values (date/time etc.)
  const variableTags = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const tag of tags) {
    const tagToMatch = tag.toLowerCase();
    const match = extractTagParts(tagToMatch);
    if (match) {
      const tagName = match[1].trim().toLowerCase();
      const operator = match[2];
      const n = Number(match[3]);
      let offset = 0;
      let specialN = '0';

      if (operator && n) {
        // Specifically for this special case, using offset to supply input date value
        if (operator === '/' && tagName === VariableTags.DaysLeftIn) {
          // eslint-disable-next-line prefer-destructuring
          specialN = match[3];
        }
        // If offset is out of allowed min max range then set it to 0 to allow its normal tag value to be added
        else if (operator !== '/' && n >= 1 && n <= 99999) {
          offset = Number(operator + n);
        }
      }

      // If offset is out of allowed min max range then set it to 0 to allow its normal tag value to be added
      if (!(n < 1 || n > 99999)) {
        offset = operator && n ? Number(operator + n) : 0;
      }

      const currentTime = timezone ? moment().tz(timezone) : moment();
      const variableTagValue = getVariableTagValue(
        tagName,
        currentTime.clone(), // to prevent the date mutation
        senderDetails,
        offset,
        specialN,
        timezone,
      );
      if (variableTagValue) {
        variableTags[`{{${tagToMatch}}}`] = variableTagValue;
      }
    }
  }
  return variableTags;
};

export const getVariableTagsMappingWithValues = (
  content: string,
  senderDetails: {
    firstName: string;
    lastName: string;
    email: string;
    signature: string;
  },
  timezone: string,
) => {
  const extractedTags = extractTags(content);

  return getVariableTagMapping(extractedTags, timezone, senderDetails);
};
